import React from 'react';
import { Forum } from '../../types/forum.types';

interface ForumItemProps {
  forum: Forum;
  onSettingsClick?: (forum: Forum) => void;
}

/**
 * ForumItem Component
 * 
 * Displays a single forum card with:
 * - Forum name
 * - Creation date
 * - Settings icon
 * 
 * Based on Figma design with proper symmetry and spacing
 */
export const ForumItem: React.FC<ForumItemProps> = ({ forum, onSettingsClick }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 p-5 mb-4 flex items-center justify-between border border-gray-100">
      <div className="flex-1 min-w-0 pr-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-1 truncate">
          {forum.name}
        </h3>
        <p className="text-sm text-gray-500">
          {formatDate(forum.creation_date)}
        </p>
      </div>
      
      <button
        onClick={(e) => {
          e.stopPropagation();
          onSettingsClick?.(forum);
        }}
        className="flex-shrink-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
        aria-label="Configuración del foro"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </button>
    </div>
  );
};
